<template>
  <div class="relative">
    <div class="h-[320px] md:h-[432px] lg:h-[576px] w-full bg-gray-200 animate-pulse" />

    <div class="absolute inset-0 p-4 md:p-10 flex flex-col justify-center self-center md:basis-2/4">
      <div class="p-4 md:p-6 rounded-lg md:max-w-[50%] bg-white bg-opacity-80">
        <div class="h-4 w-32 bg-gray-300 rounded animate-pulse mb-2" />

        <div class="h-12 w-64 bg-gray-300 rounded animate-pulse my-2" />

        <div class="h-4 w-48 bg-gray-300 rounded animate-pulse mb-4" />

        <div class="space-y-2">
          <div class="h-4 w-full bg-gray-300 rounded animate-pulse" />
          <div class="h-4 w-3/4 bg-gray-300 rounded animate-pulse" />
        </div>

        <div class="mt-6 h-12 w-36 bg-gray-300 rounded animate-pulse" />
      </div>
    </div>
  </div>
</template>
